import { createUseStyles } from "react-jss";

const styles = createUseStyles({
    companyDeletedPage: {
    // padding: "0px 54px"
  }
});

export default styles;